import React from 'react';

export const segmentPanelData = {
  completed: {
    title: 'You already completed this.',
    text: (
      <p>
        <strong>Great work!</strong> You may notice questions related to this topic in your mixed practice sets.{' '}
        <strong>If your performance weakens</strong> Magoosh will re-prioritize this topic for review in your
        study plan.
      </p>
    ),
    secondaryCTACopy: 'Review Now'
  },
  inStudyPlan: {
    title: 'This offers you a high opportunity for score improvement right now.',
    text: (
      <>
        <p>
          Good news! Learning the ins and outs of this topic on the GRE offers you a{' '}
          <strong>strong opportunity</strong> to improve your score.
        </p>
        <p>
          Once you complete this segment, you’ll <strong>continue to practice</strong> this topic in your
          mixed practice sets so you can keep your skills fresh.
        </p>
        {/* <p>
          We’re always learning, too! If you have <strong>feedback</strong> about this recommendation,
          we’d love to hear it.
        </p> */}
      </>
    ),
    // secondaryCTACopy: 'Give Feedback'
    secondaryCTACopy: 'Go to Study Plan'
  },
  notRecommended: {
    title: 'This isn’t recommended for you right now.',
    text: (
      <>
        <p>
          We want to help you focus on the areas where you have the greatest opportunity to improve your
          score. Right now, other topics are more important to your studies.
        </p>
        <p>
          You’ll still see questions related to this topic in your checkpoints (timed section practice and
          full practice tests).
        </p>
        <p>
          If you have reason to prioritize this segment you’re welcome to add it to your study plan{' '}
          <strong>before</strong> it is recommended by Magoosh.
        </p>
      </>
    ),
    secondaryCTACopy: 'Add to Study Plan'
  },
  unlikelyToContribute: {
    title: 'This is unlikely to help you improve your score.',
    text: (
      <>
        <p>
          Based on your performance so far, this topic is unlikely to offer you an opportunity to improve your
          score–either because it’s <strong>unlikely to appear</strong> on any but the hardest sections of the
          exam or because it is part of an area you’re <strong>already performing very well</strong> in.
        </p>
        <p>
          You’ll still see questions on this topic in your checkpoints (timed section practice and full
          practice tests). And if it becomes an area of opportunity, Magoosh will prioritize it in your study
          plan.
        </p>
        <p>
          You may add it to your study plan even though Magoosh has identified other activities with a greater
          potential for score improvement.
        </p>
      </>
    ),
    secondaryCTACopy: 'Add to Study Plan'
  }
};
